import { defaultSimulcastMaxBitrates } from 'utils/webrtc/environment';

export const videoSimulcastMaxBitrates = (hdBitrate: number) => ({
  ...defaultSimulcastMaxBitrates,
  high: hdBitrate,
});

export const videoSendEncodings = (
  hdEnabled: boolean,
  bitrates: ReturnType<typeof videoSimulcastMaxBitrates>
) => [
  { rid: 'h', active: hdEnabled, maxBitrate: bitrates.high },
  { rid: 'm', active: true, maxBitrate: bitrates.medium, scaleResolutionDownBy: 2 },
  { rid: 'l', active: true, maxBitrate: bitrates.low, scaleResolutionDownBy: 4 },
];
